/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@material-ui/core/';
import queryString from 'query-string';
import BudgetManualApplicationForm from './BudgetManualApplicationForm';
import Attachments from './Attachments';
import { actions as budgetActions } from '../../actions/budgetActions';
import Button from '@material-ui/core/Button';

class BudgetManualApplicationFormPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: null,
    };

    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    this.props.actions.load();
  }

  createFormInitialState() {
    const template = this.props.budget.applicationTemplate;
    return {
      budgetId: this.props.budget.id,
      form: !this.props.budget.applicationTemplate.form ? [] : this.props.budget.applicationTemplate.form.filter(d => d.type === 'text' || d.type === 'description').map(f => ({ id: f.id })),
      voter: {
        participantType: (template.voterRequiredData.naturalPersonEnabled && template.voterRequiredData.legalEntityEnabled) || (!template.voterRequiredData.naturalPersonEnabled && !template.voterRequiredData.legalEntityEnabled)
          ? null
          : template.voterRequiredData.naturalPersonEnabled ? 'naturalPerson' : 'legalEntity',
      },
    };
  }

  submitForm(data) {
    const values = queryString.parse(this.props.location.search);
    return this.props.actions.submitManualApplication(this.props.budget.id, data, values.token);
  }

  render() {
    const { budget, unit } = this.props;

    return (<React.Fragment>
      {!budget ? <div style={{ width: '100%', marginTop: 200, textAlign: 'center' }}><CircularProgress size={50} /></div> :
        <div key="content" style={{ marginTop: 40 }}>
          <div className="row">
            <div className="box">
              <div className="col-sm-12">
                <h2>{budget.applicationTemplate.title}</h2>
                <div>Dodawanie projektu w wersji papierowej</div>
              </div>
            </div>
          </div>

          {!budget.applicationTemplate.attachments || !budget.applicationTemplate.attachments.length ? null :
            <Attachments
              attachments={budget.applicationTemplate.attachments}
              unit={unit}
            />}

          <BudgetManualApplicationForm
            applicationForm={budget.applicationTemplate}
            onSubmit={this.submitForm}
            initialValues={this.createFormInitialState()}
            disabled={this.props.preview}
            budget={budget}
            parcelsAutocompletion={budget.parcelsAutocompletionEnabled}
          />
          <Dialog open={this.props.success} aria-labelledby="dialog-title" maxWidth="md">
            <DialogTitle id="dialog-title">Projekt został dodany!</DialogTitle>
            <DialogContent>
              <p>Projekt oczekuje na weryfikację zgodnie z zasadami Budżetu Obywatelskiego.</p>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => { window.location.href = 'https://' + window.location.host + '/admin/budzety/' + budget.id + '/projekty'; }} color="primary" variant="contained">
                Ok
            </Button>
            </DialogActions>
          </Dialog>
        </div>}
    </React.Fragment>);
  }
}

BudgetManualApplicationFormPage.propTypes = {
  applicationForm: PropTypes.object,
  actions: PropTypes.object.isRequired,
  budget: PropTypes.object,
  preview: PropTypes.bool,
  cms: PropTypes.object.isRequired,
  success: PropTypes.bool,
  location: PropTypes.object,
  unit: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    applicationForm: state.form.applicationForm ? state.form.applicationForm.values : null,
    budget: state.budget.current,
    success: state.budget.success,
    preview: window.location.href.includes('podglad'),
    cms: state.cms,
    unit: state.unit,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(budgetActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BudgetManualApplicationFormPage);



// WEBPACK FOOTER //
// ./src/components/budget/BudgetManualApplicationFormPage.js